import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, AM_FINANCE } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// MAIN COMPONENT
const LenderList = () => (
  <Main>
    <Title
      documentTitle="AM/Finance Lenders"
      title="AM/Finance Lenders"
      tools={<Title.AddRecord label="AM/Finance Lender" />}
    />
    <Filters>
      <Filters.Button.Active />
      <Filters.Spacer />
      <Filters.Search name="lenderName" placeholder="Search by lender name" />
    </Filters>
    <Table mobilePreviewKeys={['lender_name', 'is_active']} />
  </Main>
);

// EXPORT
export default getListData(LenderList, {
  key: 'amFinanceLenders',
  path: makePath(INTERFACE.amFinance, AM_FINANCE.lenders),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.amFinance.lenders.list
  },
  columns: [
    {
      key: 'lender_name',
      label: 'Lender',
      width: 120
    },
    COLUMNS.updatedOn,
    {
      ...COLUMNS.updatedBy,
      label: 'User'
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active lenders will be available while adding a sale.'
    }
  ],
  actions: [ACTIONS.edit('dsl_lender_id')]
});
